import React, { useContext } from "react";
import { ConfigurationContext, StepsContext } from "contexts";
import StepStart from "./StepStart";
import StepNetworkDetection from "./StepNetworkDetection";
import StepFinish from "./StepFinish";
import StepAppDetection from "./StepAppDetection";
import StepBrowserDetection from "../../features/BrowserDetection";

const Steps = (props) => {
  let config = useContext(ConfigurationContext);
  let [steps] = useContext(StepsContext);

  // Render the step.
  return config ? (
    <>
      {steps.current.index === 0 && <StepStart />}
      {steps.current.index === 1 && <StepBrowserDetection />}
      {steps.current.index === 2 && <StepAppDetection />}
      {steps.current.index === 3 && <StepNetworkDetection />}
      {steps.current.index === 4 && <StepFinish />}
    </>
  ) : null; // No configuration.
};

export default Steps;
